module.exports = __webpack_public_path__ + "static/media/logo-black.87f9dacf.svg";